var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_Arrow_Drop_Down_Filled",
    "data-name": "Icon Arrow Drop Down Filled",
    className: "cls-1",
    d: "M7,10l5,5,5-5Z",
    transform: "translate(-7 -10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDropDown);
export default __webpack_public_path__ + "static/media/Icon_ArrowDropDown.e40c17f210daf93ff0bef9544a29cf2c.svg";
export { ForwardRef as ReactComponent };